var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgUserLock = function SvgUserLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M21.25 8.5V6.75a1.75 1.75 0 1 0-3.5 0V8.5M13 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm4.6 5.5h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C23 11.74 23 11.46 23 10.9v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C22.24 8.5 21.96 8.5 21.4 8.5h-3.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C16 9.26 16 9.54 16 10.1v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.109.494.109 1.054.109Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgUserLock;